import { Component, Input } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { IAbstractView } from '@core/interfaces';
import { PricesPresenter } from './singleproduct-prices.presenter';
import { IPricesComponent } from './interfaces';

@Component({
  selector: 'app-singleproduct-prices',
  templateUrl: './singleproduct-prices.component.html',
  styleUrls: ['./singleproduct-prices.component.scss'],
  standalone: false,
  providers: [PricesPresenter]
})
export class PricesComponent 
  extends IAbstractView<PricesPresenter> 
  implements IPricesComponent 
{
  @Input() formGroup!: FormGroup;
  @Input() decimalPrecision: string = '';

  constructor(presenter: PricesPresenter) {
    super(presenter);
  }

  get pricesFormGroups(): FormGroup[] {
    return ((this.formGroup?.get('productosCanal.precios') as FormArray)?.controls as FormGroup[]) ?? [];
  }

  shouldShowPrices(): boolean {
    return this.presenter.shouldShowPrices();
  }

  hasDiscount(priceControl: FormGroup): boolean {
    return this.presenter.hasDiscount(priceControl);
  }
}
